module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCond.2c17aab.woff";